<button mat-button (click)="roomListService.startCreateRoom()">
  {{ "components.room-list.button-create-room" | translate }}
</button>
<mat-accordion>
  @for (preview of allRoomsPreview.usageSpaces; let i = $index; track i) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ preview.name }}
          @if (preview.hasRoomDraft) {
            <mat-icon>done</mat-icon>
          }
        </mat-panel-title>
      </mat-expansion-panel-header>
      <p>
        {{
          ("components.usage-space.information-table.category" | translate) +
            ": " +
            (preview.translatableCategory | translate)
        }}
      </p>
      <button
        mat-button
        (click)="roomListService.startRoomExamination(preview.id)"
      >
        {{ "components.room-selection.button-select-room" | translate }}
      </button>
    </mat-expansion-panel>
  }
</mat-accordion>
@if (allRoomsPreview.selfCreatedRooms.length > 0) {
  <div>
    <p>{{ "components.room-list.self-created-rooms" | translate }}</p>
    <mat-accordion>
      @for (
        preview of allRoomsPreview.selfCreatedRooms;
        let i = $index;
        track i
      ) {
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ preview.name }}
              @if (preview.hasRoomDraft) {
                <mat-icon>done</mat-icon>
              }
            </mat-panel-title>
          </mat-expansion-panel-header>
          <p>
            {{
              ("components.usage-space.information-table.category"
                | translate) +
                ": " +
                (preview.translatableCategory | translate)
            }}
          </p>
          <button
            mat-button
            (click)="roomListService.startRoomExamination(preview.id)"
          >
            {{ "components.room-selection.button-select-room" | translate }}
          </button>
          <button mat-button (click)="deleteSelfCreatedRoom(preview.id)">
            {{ "components.room-list.button-delete-room" | translate }}
          </button>
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
}
